import * as moment from "moment";

/**
 * Набор хелперов для работы с датой
 */
export const getDateTimeRuFormat = (dateTime: string): string => {
    return moment(dateTime).format('DD.MM.YYYY HH:mm');
};
